import React from 'react';
import { LeftContentContainer, FeedbackListWrapper, PaginationWrapper } from './style';
import FeedbackDataComponent from './FeedbackDataComponent';
import Pagination from '../../components2/Pagination';
import { getUserRole } from '../../userLocalDetails';

const FeedbackContent = ({
  feedbackList,
  pathName,
  showPagination = false,
  paginationConfig = null,
  currentPage = 0,
  onPageChange,
  isPaginationLoading = false,
}) => {
  const role = getUserRole();

  return (
    <LeftContentContainer 
      fullWidth={role === 'TEACHER'}
      showPagination={showPagination}
    >
      <FeedbackListWrapper>
        <FeedbackDataComponent
          feedbackData={feedbackList}
          pathName={pathName}
        />
      </FeedbackListWrapper>
      {showPagination && paginationConfig && (
        <PaginationWrapper>
          <Pagination
            paginationDetails={paginationConfig}
            currentPage={currentPage}
            onPageChange={onPageChange}
            isPaginationLoading={isPaginationLoading}
          />
        </PaginationWrapper>
      )}
    </LeftContentContainer>
  );
};

export default FeedbackContent;